import React, { Component } from 'react';

const styles = {
  tipBox: {
    maxWidth: "30rem",
    minWidth: "10rem",
    display: 'flex',
    position: 'absolute',
    borderRadius: '0.25rem',
    textAlign: 'justify',
    padding: '0.3125rem',
    boxSizing: "border-box",
    boxShadow: "0 0.3125rem 0.625rem rgba(255,151,59,0.3)",
    // webkitBoxShadow: "0 0.3125rem 0.625rem rgba(255,151,59,0.3)",
    zIndex: "1000",
    // cursor:"text"
  },
  bg: {
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0)",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "999",
  },
  trigger: {
    position: 'absolute',
    borderStyle: 'solid',
    borderWidth: "0.625rem 0.5rem",
  }
}


class Tip extends Component {
  static defaultProps = {
    placement: "left",
    showType: "hover"
  };

  constructor(props) {
    super(props)
    this.state = {
      isClick: false,
      // tipBoxWidth: '',
      tipBoxHeight: '',
      selLocation: false,
      demoHeight: '',
    }
  }
  componentDidMount() {
    this.setState({
      // tipBoxWidth: this.props.tipBoxWidth ? this.props.tipBoxWidth : '12.5rem',
      // tipBoxHeight: this.props.tipBoxHeight ? this.props.tipBoxHeight : '5rem',
      proportion: this.proportionFn()
    })
  }
  componentDidUpdate(preProps, preState) {
    //加判断防止一直循环渲染
    if (this.state.isClick && !preState.isClick) {
      const tipBox = this.refs.tipBox;
      console.log(tipBox.offsetHeight)
      this.setState({
        tipBoxHeight: tipBox.offsetHeight,
        tipBoxWidth: tipBox.offsetWidth
      })
    }

  }//计算录入表单最大高度
  proportionFn = () => {
    const browserInfo = this.browser();
    const chromeVersion = browserInfo.chrome

    let proportion = window.innerWidth * 16 / 1920;
    if (chromeVersion < 79) {
      const devicePixelRatio = window.devicePixelRatio;
      proportion = proportion * devicePixelRatio <= 12 ? 12 : proportion * devicePixelRatio;
    }
    return proportion
  }

  browser = () => {
    const ua = navigator.userAgent;
    const ret = {}
    const webkit = ua.match(/WebKit\/([\d.]+)/)
    const chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/)
    // eslint-disable-next-line no-useless-escape
    const ie = ua.match(/MSIE\s([\d\.]+)/) || ua.match(/(?:trident)(?:.*rv:([\w.]+))?/i)
    const firefox = ua.match(/Firefox\/([\d.]+)/)
    const safari = ua.match(/Safari\/([\d.]+)/)
    const opera = ua.match(/OPR\/([\d.]+)/);

    webkit && (ret.webkit = parseFloat(webkit[1]));
    chrome && (ret.chrome = parseFloat(chrome[1]));
    ie && (ret.ie = parseFloat(ie[1]));
    firefox && (ret.firefox = parseFloat(firefox[1]));
    safari && (ret.safari = parseFloat(safari[1]));
    opera && (ret.opera = parseFloat(opera[1]));
    return ret;
  }
  showTipBox = (type, e) => {
    e.nativeEvent.stopImmediatePropagation();
    const formBox = this.refs.formBox;
    // const tipBoxHeight = parseInt(this.state.tipBoxHeight, 10) * 16;
    const marginTop = e.nativeEvent.clientY - e.nativeEvent.offsetY;
    const marginBottom = window.innerHeight - marginTop - formBox.offsetHeight;
    if (marginBottom > marginTop) {
      this.setState({
        selLocation: "bottom"
      })
    } else {
      this.setState({
        selLocation: "top"
      })
    }
    this.setState({
      isClick: type === 'hover' ? true : !this.state.isClick,
      demoHeight: formBox.offsetHeight,
      demoWidth: formBox.offsetWidth
    })
  };


  closeTipBox = () => {
    console.log("aaaaaa")
    this.setState({
      isClick: false
    })
  };

  render() {
    let proportion = this.state.proportion
    let marginHeiht = this.state.selLocation === "bottom" ? this.state.demoHeight : this.state.tipBoxHeight//marginTop的值
    let marginTop = this.state.selLocation === "bottom" ? (marginHeiht / proportion + 0.625) + 'rem' : -(marginHeiht / proportion + 0.625) + 'rem'
    let marinLeft = this.props.placement === "left" ? -((this.state.tipBoxWidth * 0.9 - this.state.demoWidth / 2) / proportion - 0.5) + 'rem' : (this.state.demoWidth / 2 - this.state.tipBoxWidth * 0.1) / proportion - 0.5 + 'rem'
    let tipBoxStyle = {
      ...styles.tipBox,
      transform: `translate(${marinLeft},${this.state.isClick?marginTop:"-100rem"})`,
      display:`${this.state.isClick?"flex":"none"}`,
      // transition: `opacity 0.5s ease`,
      border: `0.0625rem solid ${this.props.borderColor ? this.props.borderColor : "#ff973b"}`,
      background: this.props.backgroundColor ? this.props.backgroundColor : "#faded1",
    }
    let triggerStyle = this.state.selLocation === "bottom" ?
      {
        ...styles.trigger,
        borderColor: `transparent transparent ${this.props.borderColor ? this.props.borderColor : "#ff973b"} transparent`,
        bottom: (this.state.tipBoxHeight) / proportion - 0.125 + 'rem',
      } : {
        ...styles.trigger,
        borderColor: `${this.props.borderColor ? this.props.borderColor : "#ff973b"} transparent transparent transparent`,
        top: (this.state.tipBoxHeight) / proportion - 0.125 + 'rem',
      }
    this.props.placement === "left" ? Object.assign(triggerStyle, { right: "10%" }) : Object.assign(triggerStyle, { left: "10%" })
    return (
      <div>
        <div
          style={{ position: 'absolute', cursor: "pointer" }}
          ref='formBox'
          onClick={this.props.showType === 'click' ? this.showTipBox.bind(this, 'click') : null}
          onMouseEnter={this.props.showType === 'hover' ? this.showTipBox.bind(this, 'hover') : null}
          onMouseLeave={this.props.showType === 'hover' ? this.closeTipBox : null}
        //style={{
        //   border: '1px solid black',
        //   whiteSpace: 'nowrap',
        //   overflow: 'hidden',
        //   textOverflow: 'ellipsis',
        //  cursor: 'pointer',
        //}}
        >
          {/*{this.props.title}*/}
          {this.props.children}
        </div>
          <div ref='tipBox'
            onMouseEnter={this.props.showType === 'hover' ? this.showTipBox.bind(this, 'hover') : null}
            onMouseLeave={this.props.showType === 'hover' ? this.closeTipBox : null}
            style={tipBoxStyle}>
            {/* 气泡效果 */}
            <div style={triggerStyle}>
              {/* <div
               style={this.state.selLocation == "bottom" ?
               {
               position: 'absolute', width: 0, height: '0', border: '8px solid',
               borderColor: `transparent transparent ${this.props.backgroundColor?this.props.backgroundColor:"#faded1"} transparent `,
               top: '-7px',
               left: '-8px'
               } :
               {
               position: 'absolute', width: 0, height: '0', border: '8px solid',
               borderColor: `${this.props.backgroundColor?this.props.backgroundColor:"#faded1"} transparent transparent transparent`,
               top: '-9px',
               left: '-8px'
               }
               }>
               </div> */}
            </div>
            <div style={{
              // width: this.state.tipBoxWidth,
              // height: (this.state.tipBoxHeight)/16+'rem',
              // padding: '0.3125rem',
              fontSize: "0.75rem"
            }}>{this.props.title}
            </div>
          </div>
        {this.state.isClick && this.props.showType === "click" ?
          <div onClick={this.closeTipBox.bind(this)}
            style={styles.bg}>
          </div>
          : null
        }
      </div>
    )
  }
}


export default Tip;
